function getHeaders() {
  var apiToken = $.cookie('api_token');
  return { "Authorization" : "Token token=" + apiToken, "Accept" : "application/vnd.rageon.v1" };
}
var CONTACT_CAPTCHA_RESULT;
function captchaHandler(result) {
  CONTACT_CAPTCHA_RESULT = result;
}

$(function() {
  if ($.cookie('api_token')) {
    $('#contact_form input').remove();
  }
  $("#contact-email").click(function() {
    $('#contact-modal').dialog({resizable: false, modal: true});
    $("#contact-modal .modal-close,.ui-widget-overlay").click(function() {
      $('#contact-modal').dialog("close");
    });
  });

  $('#contact_form .g-recaptcha').hide();
  $('#contact_form .message').hide();
  $('#contact_form .error').hide();
  $('#contact_form .make .text').focus(function() {
    	$('#contact_form .g-recaptcha').show();
  });

  $('#contact_form .submit').click(function(e) {
    e.preventDefault();
    const text = $('#contact_form .make .text').val();
    const senderEmail = $('#contact_form .make input').val();
    const vendor = $('.username-title').text().trim();
    const isLoggedIn = $.cookie('api_token') !== null && $.cookie('api_token') !== undefined;

    if (!text.replace(/\s/g, "").length) {
      $('#contact_form .error').show().html("Message cannot be empty!");
      return;
    }
    if (!CONTACT_CAPTCHA_RESULT) {
      $('#contact_form .error').show().html("You need to prove you're human!");
      return;
    }
    $('#contact_form .make .text').val('')
    $('#contact_form').find('.error').hide();
    const apiCall = $.ajax({
      url: window._BASEURL+"/contact_users.json",
      data: { vendor: vendor, sender_email: senderEmail, message: text, source: 'web', response: CONTACT_CAPTCHA_RESULT },
      method: 'POST',
      headers: isLoggedIn ? getHeaders() : null,
    });
    apiCall.done(function(d) {
      $('#contact_form .error').hide();
      $('#contact_form .message').show();
      grecaptcha.reset();
    });
    apiCall.fail(function(d) {
      if (d.status == 422) {
        $('#contact_form .error').text(d.responseJSON.error.message);
      } else {
        $('#contact_form .error').text("Please try again later.");
      }
      $('#contact_form .error').show();
      grecaptcha.reset();
    });
  })
});
